module.exports = __webpack_public_path__ + "static/media/selo.1050e8b6.png";